import router from '../router';
import store from '../store';
import { Message } from 'element-ui';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { getToken } from '@/utils/auth';
import { isRelogin } from '@/axios/request';

NProgress.configure({ showSpinner: false });

const whiteList = ['/login', '/auth-redirect', '/bind', '/register'];

router.beforeEach((to, from, next) => {
  NProgress.start();
  if (getToken()) {
    to.meta.title && store.dispatch('settings/setTitle', to.meta.title);
    /* has token*/
    if (to.path === '/login') {
      // 已登录访问登录页：跳转到首页，避免再经由'/'造成二次重定向
      next();
      NProgress.done();
    } else if (to.path === '/logoff') {
      next();
      NProgress.done();
    } else {
      isRelogin.show = true;
      // 判断当前用户是否已拉取完user_info信息
      store
        .dispatch('GetInfo')
        .then(() => {
          isRelogin.show = false;
          // 拉取信息后进入首页（使用绝对路径）
          next();
        })
        .catch((err) => {
          store.dispatch('LogOut').then(() => {
            Message.error(err);
            next({ path: '/' });
          });
        });
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      if (to.fullPath === '/logoff') {
        next();
      } else {
        next(`/login?redirect=${to.fullPath}`); // 否则全部重定向到登录页
      }
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});